<template>
  <div class="article-role-selector">
    <dd class="one-column">
      <label class="select-input">
        <span>Admin - ผู้สร้างและประกาศข่าวทุกโครงการ</span>
        <input
          v-model="articleRole"
          :value="adminRole"
          type="radio"
          name="articleRole"
          @click="handleChange(adminRole)"
        />
        <span class="checkmark radio"></span>
      </label>
      <label v-if="canSelectArticleRoleAdminOnly" class="select-input gray">
        <span>Editor - ผู้สร้างและอนุมัติประกาศข่าวเฉพาะโครงการที่ดูแล</span>
        <input v-model="articleRole" type="radio" value="2" disabled />
        <span class="checkmark radio"></span>
      </label>
      <label v-else class="select-input">
        <span>Editor - ผู้สร้างและอนุมัติประกาศข่าวเฉพาะโครงการที่ดูแล</span>
        <input
          v-model="articleRole"
          :value="editorRole"
          type="radio"
          name="articleRole"
          @click="handleChange(editorRole)"
        />
        <span class="checkmark radio"></span>
      </label>
      <label v-if="canSelectArticleRoleAdminOnly" class="select-input gray">
        <span>Creator - ผู้สร้างประกาศข่าวเฉพาะโครงการที่ดูแล</span>
        <input v-model="articleRole" type="radio" value="3" disabled />
        <span class="checkmark radio"></span>
      </label>
      <label v-else class="select-input">
        <span>Creator - ผู้สร้างประกาศข่าวเฉพาะโครงการที่ดูแล</span>
        <input
          v-model="articleRole"
          :value="creatorRole"
          type="radio"
          name="articleRole"
          @click="handleChange(creatorRole)"
        />
        <span class="checkmark radio"></span>
      </label>
    </dd>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: null,
      default: undefined,
    },
    isCreatingStaff: {
      type: null,
      default: undefined,
    },
    roles: {
      type: null,
      default: undefined,
    },
    staffRoleId: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    articleRole: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    canSelectArticleRoleAdminOnly() {
      if (!this.roles || !this.staffRoleId) {
        return false
      }

      const roleName = this.roles.find(
        (role) => role.role_id === this.staffRoleId,
      ).role_name

      return ["Admin"].includes(roleName)
    },
    adminRole() {
      return 1
    },
    editorRole() {
      return 2
    },
    creatorRole() {
      return 3
    },
  },
  watch: {
    canSelectArticleRoleAdminOnly() {
      if (this.isCreatingStaff) {
        this.handleChange(this.adminRole)
      }
    },
  },
  methods: {
    handleChange(value) {
      this.$emit("input", value)
    },
  },
}
</script>

<style lang="scss" scoped>
.article-role-selector {
  dd {
    &.one-column {
      display: table-caption;
      column-count: 1;
      margin-left: 76px;

      .select-input > span:first-child {
        width: 30em;
        display: inline-block;
      }
    }
  }
}

.gray {
  color: #cdcdcd;
}
</style>
